module.exports = thousandMultiples = [
  "",
  "هزار",
  "میلیون",
  "میلیارد",
  "بیلیون",
  "بیلیارد",
  " تریلیون",
  " تریلیارد",
  " کوآدریلیون",
  "کادریلیارد",
  "کوینتیلیون",
  " کوانتینیارد",
  "سکستیلیون",
  " سکستیلیارد",
  "سپتیلیون",
  "سپتیلیارد",
  "اکتیلیون",
  "اکتیلیارد",
  "نانیلیون",
  "نانیلیارد",
  "دسیلیون",
  "دسیلیارد",
  "گوگول",
  " گوگول پلکس",
  "گوگول پلکسیان"
];
